import { Component, Input, EventEmitter, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CreateTaxiVehicleModel, VehicleBrandModel, VehicleModel, XpressUserRoleEnum } from 'app/models';
import { RiderService, VehicleBrandService, XpressUserService } from 'app/services';
import { MessageService } from 'primeng/api';
import { TaxiVehiclesComponent } from '../taxi-vehicles.component';

//This component is used for create and edit Taxi Driver's vehicle
@Component({
	selector: 'create-taxi-vehicle',
	templateUrl: './create-taxi-vehicle.component.html',
	styleUrls: ['./create-taxi-vehicle.component.scss']
})
export class CreateTaxiVehicleComponent implements OnInit, OnChanges {
	@Input()
	public taxiVehiclesComponent!: TaxiVehiclesComponent;

	@Input()
	public showDriverAddSideBar: boolean = false;

	@Input()
	public vehicleToEdit: any = null;

	@Output() changedShowTaxiVehicleAddSideBarEmit = new EventEmitter<boolean>();
	changedShowTaxiVehicleAddSideBar(increased: any) {
		this.changedShowTaxiVehicleAddSideBarEmit.emit(increased);
	}

	public vehicle: CreateTaxiVehicleModel = new CreateTaxiVehicleModel();
	public isEditMode: boolean = false;

	public vehicleBrands: any = [];
	public vehicleModels: VehicleModel[] = [];

	constructor(private messageService: MessageService,
		private riderService: RiderService,
		private vehicleBrandService: VehicleBrandService) { }

	ngOnInit(): void {
		this.getVehicleBrands();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['vehicleToEdit'] && this.vehicleToEdit) {
			this.isEditMode = true;
			this.vehicle = new CreateTaxiVehicleModel({
				Id: this.vehicleToEdit.Id,
				Year: this.vehicleToEdit.Year,
				BrandId: this.vehicleToEdit.BrandId,
				ModelId: this.vehicleToEdit.ModelId,
				ChassisNumber: this.vehicleToEdit.ChassisNumber,
				NumberPlate: this.vehicleToEdit.NumberPlate,
				LTFRBCaseNumber: this.vehicleToEdit.LTFRBCaseNumber ?? ''
			});
			this.getVehicleModels();
		} else if (changes['showDriverAddSideBar'] && !this.showDriverAddSideBar) {
			this.isEditMode = false;
			this.vehicle = new CreateTaxiVehicleModel();
		}
	}

	private getVehicleBrands() {
		const dto = {
			VehicleType: null,
		};

		this.vehicleBrandService.getVehicleBrands(dto, this.messageService)
			.then(data => {
				if (!data) { return; }

				if (!data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
					return;
				}

				this.vehicleBrands = VehicleBrandModel.mapToVehicleBrandModels(data.Items);
			});
	}

	public addVehicle() {
		if (!this.vehicle.IsAllFieldsFilled()) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all fields' });
			return;
		}
		const extra = this.taxiVehiclesComponent.getVehiclePoolRequestExtras();
		const body = { ...this.vehicle, ...extra };
		const promise = this.isEditMode
			? this.riderService.updateTaxiVehicle(body, this.messageService)
			: this.riderService.createTaxiVehicle(body, this.messageService);
		promise
			.then(data => {
				if (!data) {
					return;
				}

				if (!data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
					return;
				}
				this.taxiVehiclesComponent.skip = 0;
				this.taxiVehiclesComponent.callVehiclePageTitles();
				this.cancel();
			});
	}

	cancel() {
		this.isEditMode = false;
		this.vehicle = new CreateTaxiVehicleModel();
		this.changedShowTaxiVehicleAddSideBar(false);
	}

	public onChangeVehicleMakeEvent(event: any) {
		this.vehicle.ModelId = null;
		if (this.vehicle.BrandId) {
			this.getVehicleModels();
		}
	}

	private getVehicleModels() {
		const dto = {
			VehicleBrandId: this.vehicle.BrandId,
		};

		this.vehicleBrandService.getVehicleModels(dto, this.messageService)
			.then(data => {
				if (!data) { return; }

				if (!data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
					return;
				}

				this.vehicleModels = VehicleModel.mapToVehicleModels(data.Items);
			});
	}
}
